<script setup lang="ts"></script>

<template>
  <div>
    <NuxtLayout name="default">
      404
      <Headline content="Oh No! 4-0-Fo!" size="xl" color="secondary" />
      <Text
        as="p"
        size="lg"
        class="mx-auto max-w-md mt-4 text-red-900"
        content="Oops! The page you are looking for does not exist."
      ></Text>
    </NuxtLayout>
  </div>
</template>
